export enum SystemsExternalTypeEnum {
  SYSTEM = 'SISTEMA',
  APPLICATION = 'APLICAÇÃO'
}

export enum SystemsExternalTypeIdEnum {
  'SISTEMA' = 1,
  'APLICAÇÃO' = 2,
  SYSTEM,
  APPLICATION
}

export function getSystemsExternalTypeDescriptionByValue(value: number) {
  const indexOfS = Object.values(SystemsExternalTypeIdEnum).indexOf(
    value as unknown as SystemsExternalTypeIdEnum
  );

  const key = Object.keys(SystemsExternalTypeIdEnum)[indexOfS];

  return key;
}


